import React from 'react';
import './MessageIcon.css';

const MessageIcon = () => {
  return (
    <div className="icon-wrapper">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="message-icon-svg"
      >
        <path d="M12 21c4.97 0 9-3.58 9-8s-4.03-8-9-8-9 3.58-9 8c0 1.65.53 3.22 1.52 4.52l-1.34 3.98 4.07-1.36C10.04 20.49 11.02 21 12 21z"></path>
        <line x1="8" y1="10" x2="16" y2="10"></line>
        <line x1="8" y1="13" x2="13" y2="13"></line>
      </svg>
    </div>
  );
};

export default MessageIcon;